import { render, staticRenderFns } from "./AmbulanciasDetalle.vue?vue&type=template&id=e62f9e1a"
import script from "./AmbulanciasDetalle.vue?vue&type=script&lang=js"
export * from "./AmbulanciasDetalle.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports